import { Link } from "react-router-dom";
import { Play } from "lucide-react";

const cols = [
  { title: "Explore", links: [["Shop","/shop"], ["Science","/science"], ["Testing","/testing"], ["About","/about"]] },
  { title: "Support", links: [["FAQ","/faq"], ["Track Order","/track"], ["Contact","/contact"], ["Shipping","/legal/shipping"], ["Returns","/legal/returns"]] },
  { title: "Account", links: [["Sign In","/login"], ["Create Account","/register"], ["Member Area","/account"]] },
  { title: "Legal", links: [["Privacy","/legal/privacy"], ["Terms","/legal/terms"], ["Shipping Policy","/legal/shipping-policy"], ["Research Disclaimer","/legal/disclaimer"], ["Age Verification","/legal/age-verification"], ["Cookie Policy","/legal/cookies"]] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/5 bg-black">
      <img src="/assets/emblem.png" alt="" aria-hidden
        className="pointer-events-none absolute -right-24 -bottom-24 w-[520px] opacity-[0.06]" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid gap-14 lg:grid-cols-6">
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center gap-3">
              <img src="/assets/emblem.png" alt="" className="w-10" />
              <div>
                <div className="font-display uppercase tracking-[0.28em] text-white">BIO LABZ</div>
                <div className="font-mono text-[10px] tracking-[0.35em] text-white/40 mt-1">REGENERATION</div>
              </div>
            </div>
            <h4 className="font-display uppercase text-2xl leading-tight text-white max-w-sm">Peptide science.<br/>Human potential.</h4>
            <p className="text-white/50 text-sm max-w-md">
              Research compounds sourced and presented with scientific rigor.
              Every product is traceable. Every batch tells a story.
            </p>
            <p className="font-mono text-xs text-white/60">
              <a href="mailto:support@regenbiolabz.com" data-testid="footer-support-email" className="hover:text-white">support@regenbiolabz.com</a>
              <span className="text-white/25"> · </span>
              <a href="mailto:sales@regenbiolabz.com" data-testid="footer-sales-email" className="hover:text-white">sales@regenbiolabz.com</a>
            </p>
          </div>

          {cols.map(col => (
            <div key={col.title}>
              <div className="bl-eyebrow mb-5">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <Link
                      to={to}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g,'-')}`}
                      className="text-white/70 hover:text-[color:var(--bl-blue)] transition-colors text-sm">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
            <div className="font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase">
              © {new Date().getFullYear()} Regeneration Bio Labz · regenbiolabz.com · All rights reserved
            </div>
            <button
              type="button"
              data-testid="footer-replay-intro"
              onClick={() => { window.scrollTo({ top: 0, behavior: "auto" }); window.dispatchEvent(new CustomEvent("bl:replay-intro")); }}
              className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.28em] uppercase text-[color:var(--bl-blue)]/80 hover:text-[color:var(--bl-blue)] transition-colors"
            >
              <Play size={11} /> Replay brand film
            </button>
          </div>
          <div className="font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase max-w-xl">
            Products supplied for laboratory research only. Not for human or veterinary use.
          </div>
        </div>
      </div>
    </footer>
  );
}
